<template>
    <div class="row justify-center">
        <div class="col-12 text-center">
            <router-link :to="{name: homeLink}">
                <q-img :src="logo" :style="logoStyle" />
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ClientLogo',

    computed: {
        ...mapGetters({
            logo: 'params/logo',
            use_portfolio_page: 'params/use_portfolio_page'
        }),

        logoStyle() {
            if (this.$q.platform.is.desktop) {
                if (process.env.PROJECT_FOLDER === 'universidadechevrolet') return { maxHeight: '5.5rem', maxWidth: '10rem' }
                else if (process.env.PROJECT_FOLDER === 'academiacoral') return { maxHeight: '5rem', maxWidth: '10rem' }
                else if (process.env.PROJECT_FOLDER === 'academiaalba') return { maxHeight: '5rem', maxWidth: '10rem' }
                else if (process.env.PROJECT_FOLDER === 'academiainca') return { maxHeight: '5rem', maxWidth: '10rem' }
                else if (process.env.PROJECT_FOLDER === 'electroluxinstala') return { maxHeight: '4rem', maxWidth: '20rem'  }
                else if (process.env.PROJECT_FOLDER === 'eluxacademy') return { maxHeight: '8rem', maxWidth: '20rem'  }
                else return { maxHeight: '4rem', maxWidth: '10rem' }
            }
            else {
                if (process.env.PROJECT_FOLDER === 'universidadechevrolet') return { maxHeight: '2.5rem', maxWidth: '7rem' }
                else if (process.env.PROJECT_FOLDER === 'academiacoral') return { maxHeight: '4rem', maxWidth: '8rem' }
                else if (process.env.PROJECT_FOLDER === 'academiaalba') return { maxHeight: '4rem', maxWidth: '8rem' }
                else if (process.env.PROJECT_FOLDER === 'academiainca') return { maxHeight: '4rem', maxWidth: '8rem' }
                else if (process.env.PROJECT_FOLDER === 'electroluxinstala') return { maxHeight: '4rem', maxWidth: '20rem'  }
                else if (process.env.PROJECT_FOLDER === 'eluxacademy') return { maxHeight: '5rem', maxWidth: '20rem' }
                else return { maxHeight: '3rem', maxWidth: '8rem' }
            }
        },

        homeLink() {
            if (!this.use_portfolio_page) return 'login'
            else return 'portfolio'
        }
    }
}
</script>

<style>

</style>